module.exports = __webpack_public_path__ + "img/fillintheblanks.b307a8cf.png";